import React, { useState } from 'react'

import iitKgpCoverImage from 'img/iitkgpcover.jpg'
import CoverImage from 'components/article/coverimage'


const HeroLogo = (props) => {
  return (
  <CoverImage src={iitKgpCoverImage} focusX={'44%'} focusY={'45%'} />)
}

export default HeroLogo
